export enum ParkingLot {
  Private = "PRIVATE",
  Company = "COMPANY",
}
